<small style="display: none">{{ appVersion }}</small>
@if (showContent()) {
  <div class="app-container">
    <router-outlet />
    <app-snackbar />
  </div>
}
